function customInputNumberListeners(form) {
  const formAction = form.getAttribute('action')
  const minimumValue = formAction === '/cart' ? 0 : 1
  form.querySelectorAll('.input-number-wrapper button').forEach((button) => {
    button.addEventListener('click', async () => {
      const inputElement = button.parentElement.querySelector('input')
      let currentQuantity = Number(inputElement.value)
      const increment = button.classList.contains('plus')
      //this increments and decrements (with a minimum value of 0)
      const newQuantity = increment
        ? currentQuantity + 1
        : currentQuantity > minimumValue
        ? currentQuantity - 1
        : minimumValue

      inputElement.value = newQuantity //set value in ui immediately
      inputElement.dispatchEvent(new Event('change', { bubbles: true }))
    })
  })
}

;(function () {
  const addToCartForm = document.querySelector('form[action="/cart/add"]')
  if (addToCartForm) {
    customInputNumberListeners(addToCartForm)
  }
})()
